import { render } from "./InteractiveGraphicEditor.vue?vue&type=template&id=819a88da"
import script from "./InteractiveGraphicEditor.vue?vue&type=script&lang=js"
export * from "./InteractiveGraphicEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__